module.exports = __webpack_public_path__ + "static/media/web_page_1.3d47cc91.png";